import styled from "@emotion/styled";

export const StyledSwitchContainer = styled.div`
  margin-left: -12px;
`;
